export default {
  title: 'Track deine Bestellung',
  text: 'Geliefert mit',
  buttons: {
    track_driver: 'Erhalte Updates zur Bestellung →',
  },
};
